var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24729 16.269C4.28353 9.58321 9.58669 4 16.2726 4V4C22.7495 4 28 9.25054 28 15.7274V16C28 22.6274 22.6275 28 16 28C10.8467 28 5.5717 28 3.66541 28C3.41545 28 3.24518 27.6502 3.33474 27.4168C4.00893 25.66 4.22173 20.9845 4.24729 16.269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeist);
export default __webpack_public_path__ + "static/media/geist.8d7333611131b36d77b8bd61af6b07bb.svg";
export { ForwardRef as ReactComponent };